import {
  formatMigrationDate,
  formatShortMigrationDate,
} from '@/components/layout/oci-migration-notice/migration-schedule/utils'
import { COMPANY_MIGRATION_SCHEDULE_QUERY } from '@/components/layout/oci-migration-notice/queries'
import { useSuspenseQuery } from '@/lib/hooks'
import type {
  CompanyClusterMigrationScheduleQuery,
  CompanyClusterMigrationScheduleQueryVariables,
} from '@/components/layout/oci-migration-notice/queries.types.gen'

type MigrationButtonLabelProps = {
  idCompany: string
  waveLabel: string
}

export const MigrationButtonLabel = ({
  idCompany,
  waveLabel,
}: MigrationButtonLabelProps) => {
  const { data } = useSuspenseQuery<
    CompanyClusterMigrationScheduleQuery,
    CompanyClusterMigrationScheduleQueryVariables
  >(COMPANY_MIGRATION_SCHEDULE_QUERY, {
    variables: { idCompany },
    errorPolicy: 'all',
  })

  const schedule = data?.companyClusterMigrationSchedule

  if (schedule?.status === 'started') {
    return <>Migration in progress</>
  }

  if (schedule?.status === 'scheduled' && schedule.scheduledAt) {
    return (
      <time
        dateTime={schedule.scheduledAt}
        title={formatMigrationDate(schedule.scheduledAt)}
      >
        Migration - {formatShortMigrationDate(schedule.scheduledAt)}
      </time>
    )
  }

  return <>Migration - {waveLabel}</>
}
